export default __webpack_public_path__ + "static/media/aptus-logo-full-colour.0db73ec1.png";